export default {
  search: "",
  list: [],
  page: 1,
  limit: 10,
  total: 0,
};
